import React from 'react';
const SvgDownload: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 14V7M15 11l-3 3-3-3M9 17h6"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.364 5.636A9 9 0 115.636 18.364 9 9 0 0118.364 5.636"
      />
    </svg>
  );
};
export default SvgDownload;
